var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"w-100 fill-height"},[_c('keep-alive',{attrs:{"include":"List,IntegrationsList,UsersList"}},[_c('router-view',{key:_vm.$route.fullPath + _vm.$route.meta.groupCompany})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }